import { render, staticRenderFns } from "./DoctorsList.vue?vue&type=template&id=5e7d590e&scoped=true&"
import script from "./DoctorsList.vue?vue&type=script&lang=js&"
export * from "./DoctorsList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsList.vue?vue&type=style&index=0&id=5e7d590e&lang=scss&scoped=true&"
import style1 from "./DoctorsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d590e",
  null
  
)

export default component.exports